import React from 'react';
import PropTypes from 'prop-types';
import gql from 'graphql-tag';
import Icon from '../../../../modules/react/components/stateless/Icon';
import FacilityImage from '../../../containers/FacilityImage';
import Address from '../Address';
import FacilityLink from '../FacilityLink';
import FacilityName from '../FacilityName';
import StarRack from '../StarRack';
import Phone from '../Phone';
import style from './FacilityPicWithAddress.scss';

const propTypes = {
  facility: PropTypes.shape({
    id: PropTypes.string,
    settings: PropTypes.object,
    rating: PropTypes.number,
    primaryImage: PropTypes.string,
    displayName: PropTypes.string,
    address: PropTypes.string,
    phone: PropTypes.string,
  }),
  isEditable: PropTypes.bool,
};

const defaultProps = {
  facility: undefined,
  isEditable: undefined,
};

const renderDistance = (facility) => { // eslint-disable-line react/prop-types
  if (!facility.distance) {
    return false;
  }

  return (
    <div>
      <Icon
        className={`${style.mapPin} color-secondary-foreground`}
        id="locations-pin"
      />
      {' '}
      {facility.distance} miles
    </div>
  );
};

const renderAddressDescription = (facility) => {
  if (facility.settings && facility.settings.businessAddressDescription) {
    return (
      <div className={style.addressModifier}>{facility.settings.businessAddressDescription}</div>
    );
  }
  return '';
};

const renderTagline = (facility) => {
  if (facility.settings && facility.settings.tagline) {
    return (
      <div className={style.tagline}>{facility.settings.tagline}</div>
    );
  }
  return '';
};

const FacilityPicWithAddress = ({ facility, isEditable }) => {
  if (!facility) {
    return false;
  }

  return (
    <FacilityLink
      facility={facility}
      className={style.container}
      isEditable={isEditable}
    >
      <div className={style.greyBar}>
        {renderDistance(facility)}
        {facility.rating > 0
          ? (
            <StarRack
              className={style.starRack}
              rating={facility.rating}
            />
          )
          : ''}
      </div>
      <FacilityImage
        facility={facility}
        alt={facility.displayName}
        className={style.image}
      />
      <div className={style.details}>
        <div className={`${style.name} color-primary-foreground`}>
          <FacilityName {...facility} />
        </div>
        {renderAddressDescription(facility)}
        <Address
          {...facility.address}
          className={style.address}
          multiLine
        />
        <Phone
          number={facility.phone}
          element="div"
          className={`${style.phone} color-secondary-foreground`}
        />
        {renderTagline(facility)}
      </div>
    </FacilityLink>
  );
};

FacilityPicWithAddress.propTypes = propTypes;
FacilityPicWithAddress.defaultProps = defaultProps;

FacilityPicWithAddress.fragments = {
  facility: gql`
    fragment FacilityPicWithAddressFacility on Facility {
      address {
        ...FacilityAddress
      }
      distanceFromCurrentUserInMiles
      displayName
      rating
      settings {
        tagline
        businessAddressDescription
      }
      ...FacilityLinkFacility
      ...FacilityNameFacility
      ...FacilityPhone
      ...FacilityImageFacility
    }

    ${Address.fragments.address}
    ${FacilityLink.fragments.facility}
    ${FacilityName.fragments.facility}
    ${Phone.fragments.facility}
    ${FacilityImage.fragments.facility}
  `,
};

export default FacilityPicWithAddress;
